export default __webpack_public_path__ + "static/media/OptimizeObligation.756fba75.jpg";